import { render, staticRenderFns } from "./expert_review.vue?vue&type=template&id=f45abcb0"
import script from "./expert_review.vue?vue&type=script&lang=js"
export * from "./expert_review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports